// extracted by mini-css-extract-plugin
export default {"sort":"US-z","sortSelect":"VS-z","disabled":"WS-z"};